import { Control, FieldValues } from "react-hook-form";

import { TextFieldProps } from "@mui/material";

import { FormSelectField } from "../FormSelectField";

import { primaryInsuredTypeOption } from "./utils";

type Props<TValue extends FieldValues> = Omit<TextFieldProps, "variant"> & {
  control: Control<TValue>;
  name?: string;
  label?: React.ReactNode;
  placeholder?: string;
  optional?: boolean;
  fontSize?: number;
  labelFontSize?: number;
};

export const FormPrimaryInsuredTypeSelect = <TValue extends FieldValues>({
  control,
  name = "type",
  label = "Primary insured type",
  placeholder = "Select...",
  optional = false,
  disabled = false,
  fontSize,
  labelFontSize,
}: Props<TValue>) => {
  return (
    <FormSelectField
      id="primary-insured-type"
      dataTestId="primary-insured-input"
      name={name}
      control={control}
      options={primaryInsuredTypeOption}
      label={label}
      placeholder={placeholder}
      optional={optional}
      disabled={disabled}
      fontSize={fontSize}
      labelFontSize={labelFontSize}
      fullWidth
    />
  );
};
